// extracted by mini-css-extract-plugin
export default {"button":"SiTj8u","text":"F9DaIX","active":"q7V4xK"};